import api from './axiosInstance';
import { NotificationType, NotificationStage } from '../const/NotificationTypes';

export interface NotificationPreference {
  id?: string;
  userId?: string;
  email: string;
  type: NotificationType;
  customStages: NotificationStage[];
  isEnabled: boolean;
  weeklyEnabled: boolean;
  weeklyType: NotificationType;
  weeklyCustomStages: NotificationStage[];
  dailyEnabled: boolean;
  dailyType: NotificationType;
  dailyCustomStages: NotificationStage[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateNotificationPreferenceRequest {
  email: string;
  type: NotificationType;
  customStages: NotificationStage[];
  isEnabled: boolean;
  weeklyEnabled?: boolean;
  weeklyType?: NotificationType;
  weeklyCustomStages?: NotificationStage[];
  dailyEnabled?: boolean;
  dailyType?: NotificationType;
  dailyCustomStages?: NotificationStage[];
}

export interface UpdateNotificationPreferenceRequest {
  type: NotificationType;
  customStages: NotificationStage[];
  isEnabled: boolean;
  weeklyEnabled?: boolean;
  weeklyType?: NotificationType;
  weeklyCustomStages?: NotificationStage[];
  dailyEnabled?: boolean;
  dailyType?: NotificationType;
  dailyCustomStages?: NotificationStage[];
}

class NotificationPreferencesService {
  // Create a notification preference
  async create(preference: CreateNotificationPreferenceRequest): Promise<NotificationPreference> {
    const response = await api.post('/api/notification-preferences', preference);
    return response.data;
  }

  // Get preferences for authenticated user
  async getMyPreferences(): Promise<NotificationPreference[]> {
    const response = await api.get('/api/notification-preferences/me');
    return response.data;
  }

  // Get all preferences for a user by email
  async getByEmail(email: string): Promise<NotificationPreference[]> {
    const response = await api.get(`/api/notification-preferences/${email}`);
    return response.data;
  }

  // Get a specific preference by id and email
  async getById(id: string, email: string): Promise<NotificationPreference> {
    const response = await api.get(`/api/notification-preferences/${id}/${email}`);
    return response.data;
  }

  // Update a preference by id and email
  async update(id: string, email: string, preference: UpdateNotificationPreferenceRequest): Promise<NotificationPreference> {
    const response = await api.put(`/api/notification-preferences/${id}/${email}`, preference);
    return response.data;
  }

  // Delete a preference by id and email
  async delete(id: string, email: string): Promise<void> {
    await api.delete(`/api/notification-preferences/${id}/${email}`);
  }
}

export default new NotificationPreferencesService();
